<dialog #modal class="root-container no-scrollbar" [ngClass]="classes" (keydown.enter)="!disabled && positiveAction()">
  <i class="fa-solid fa-xmark close-button" (click)="onDismiss()"></i>
  <div class="title">{{ title }}</div>
  @if (message) {<div class="message">{{ message }}</div>}
  <div class="my-4">
    <ng-content></ng-content>
  </div>
  <div class="button-container" [style.justify-content]="buttonPosition">
    @if(type == 'confirm' || type == 'confirm-warning'){
      <button class="default main-btn" (click)="negativeAction()">{{ negative_text }}</button>
    }
    @if(type == 'info' || type == 'confirm'){
      <button class="primary main-btn" [ngClass]="{disabled: disabled}" (click)="!disabled && positiveAction()">{{ positive_text }}</button>
    }
    @if(type == 'confirm-warning'){
      <button class="warning main-btn" (click)="!disabled && positiveAction()">{{ positive_text }}</button>
    }

  </div>
</dialog>
